/* eslint-disable */
import React, { useEffect, useState } from 'react';
import healthTest from 'api/health-test';

const StatusDisplay = ({ status }) => {
  if (status) {
    return (
      <>
        {Object.keys(status).map((objKey, idx) => (
          <div key={idx}>
            <span>{`${objKey}: `}</span>
            <span>{JSON.stringify(status[objKey])}</span>
          </div>
        ))}
      </>
    );
  }
  return <div>Status: No result yet.</div>;
};

const ApiHealthTest = () => {
  const [healthStatus, setHealthStatus] = useState(null);

  useEffect(() => {
    const getApiHealth = async () => {
      const status = await healthTest();
      setHealthStatus(status);
    };
    if (!healthStatus) {
      setHealthStatus('pending');
      getApiHealth();
    }
  }, [healthStatus]);

  return (
    <div>
      <br />
      <span>API Health test result:</span>
      <StatusDisplay status={healthStatus} />
    </div>
  );
};

export default ApiHealthTest;
